import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';

import { CLAOption } from '../../../CLA/SalaryScales/types';

import { getCLAOptions } from 'RestAPIs/admin';

import { showSnackbar } from 'components/shared';

export const useGetClaData = () => {
  const { t } = useTranslation('common');

  return useQuery({
    queryKey: ['cla', 'get'],
    queryFn: async () => {
      const { data } = await getCLAOptions();
      return data as CLAOption[];
    },
    onError: () => {
      showSnackbar({
        severity: 'error',
        message: t('adminPortal.tables.errorAtCla')
      });
    }
  });
};
